import { createContext, useContext } from 'react'

const WizardContext = createContext()

export const WizardProvider = WizardContext.Provider
export const useWizardContext = () => useContext(WizardContext)
